module.exports = __webpack_public_path__ + "img/gb9118_3_l1.prt.324b1f8a.jpg";